var lib_core = require("lib-core");

var SwitcherItemModel = function(data, level, config, isJson) {
    var self = this;
    this.makeObservableTreeNode();

    this.data = data;
    this.level = level;
    this.readOnly = config && this.level >= config.readOnlyLevel;

    this.selected = this.value("selected", true);
    this.subItems = this.list("subItems", true);
    this.isJson = isJson;
    this.config = config;

    var subLevel = this.level + 1;
    if (config && subLevel < config.collections.length && !isJson){
        this.setupSubCollection();
        // TODO add onSwap handler: when items in collection changed positions, IM needs to be updated as well
    }
};
lib_core.mixin(SwitcherItemModel, lib_core.ObservableTreeNode);
SwitcherItemModel.$class = "SwitcherModel";

SwitcherItemModel.prototype.dejsonifyItem = function(dataRoot, collection){
   
    var correctItemData = dataRoot.dejsonify(this.data); //dejsonify recursivly
    collection.replaceWithoutTriggers(correctItemData, this.data);
    this.data = correctItemData; // set item data to node

    // set up sub collection if necessary
    var subLevel = this.level + 1;
    if (this.config && subLevel < this.config.collections.length){
        this.setupSubCollection();
    }
    this.isJson = false;
}


SwitcherItemModel.prototype.setupSubCollection = function(){
    var self = this;
    var subLevel = this.level + 1;
    this.subCollection = this.data.collections.get(this.config.collections[subLevel][0]) ||  this.data.instanceCollections.get(this.config.collections[subLevel][0]); // TODO: does not really searches a path, only works for direct collection in sub level

    this.subCollection.forEach(function(idx, data){   // add sub items if there is a sublevel
        var switcherItemModel = new SwitcherItemModel(data, subLevel, self.config);
        self.subItems.add(idx, switcherItemModel);
    });

    this.subCollection.onAdd(this, function(idx, data){
        var switcherItemModel = new SwitcherItemModel(data, subLevel, self.config);
        self.subItems.add(idx, switcherItemModel);
    });
    this.subCollection.onRemove(this, function(idx, data){
        self.subItems.remove(idx);
    });
}

SwitcherItemModel.prototype.getTitle = function() {
    var obj = this.data;
    if(!obj.isObservableTreeNode) return null;
    while (obj && !obj.getTitle) obj = obj.template();    // search in instanceChain for title function TODO: this is maybe not the best / cleanest way to put this logic
    return obj && obj.getTitle ? obj.getTitle() : null;
};

SwitcherItemModel.prototype.getThumbnailURL = function() {
    var obj = this.data;
    if(!obj.isObservableTreeNode) return null;
    while (obj && !obj.getThumbnailURL) obj = obj.template();
    return obj && obj.getThumbnailURL ? obj.getThumbnailURL() : null;
};

SwitcherItemModel.prototype.remove = function() {
    if (!this.readOnly) this.data.remove();
    else if (this.parent() instanceof SwitcherItemModel) this.parent().remove();    // if this level is readonly, directly remove parent, if toplevel is also readonly, remove is not allowed
};

SwitcherItemModel.prototype.searchData = function(data){
    if (this.data == data) return this;
    else {
        var item = null;
        this.subItems.forEach(function(i, subItem){
            item = item || subItem.searchData(data);
        });
        return item;
    }
};

SwitcherItemModel.$class = "SwitcherItemModel";
module.exports = SwitcherItemModel;